import React, { createContext, useCallback, useContext, useState, ReactNode } from "react";
import { EmpreenderApps } from "../files/AppsArray";
import { PerguntasFrequentes } from "../files/AppsPerguntas";
const { v4: uuidv4 } = require("uuid");

interface PerguntaContextData {
  pergunta: string;
  setPergunta: (value: string) => void;
  limparPergunta: () => void;
  appSlug: string;
  setAppSlug: (value: string) => void;
  appName: string;
  setAppName: (value: string) => void;
  conversaAtual: string;
  setConversaAtual: (value: string) => void;
  perguntasAppAtual: string[];
  // Pergunta cuja chamada à IA falhou, para o botão "Tentar de novo".
  erroPergunta: string | null;
  setErroPergunta: (value: string | null) => void;
  // Pergunta original que acompanha a próxima mensagem do usuário quando ele disse que a
  // resposta não resolveu. A SAK recebe só a mensagem atual, então o contexto vai junto.
  contextoPendente: string | null;
  setContextoPendente: (value: string | null) => void;
}

const PerguntaContext = createContext<PerguntaContextData | undefined>(
  undefined
);

export const PerguntaProvider = ({ children }: { children: ReactNode }) => {
  const aplicativoInicial = EmpreenderApps[0];

  const [pergunta, setPergunta] = useState<string>("");
  const [appSlug, setAppSlug] = useState<string>(aplicativoInicial?.slug || "");
  const [appName, setAppName] = useState<string>(aplicativoInicial?.name || "");
  const [conversaAtual, setConversaAtual] = useState<string>(uuidv4());
  const [erroPergunta, setErroPergunta] = useState<string | null>(null);
  const [contextoPendente, setContextoPendente] = useState<string | null>(null);

  // Obtém as perguntas do appSlug atual
  type AppSlugs = keyof typeof PerguntasFrequentes;
  const perguntasAppAtual = PerguntasFrequentes[appSlug as AppSlugs] || [];

  const limparPergunta = useCallback(() => {
    setPergunta("");
  }, []);

  return (
    <PerguntaContext.Provider
      value={{
        pergunta,
        setPergunta,
        limparPergunta,
        appSlug,
        setAppSlug,
        appName,
        setAppName,
        conversaAtual,
        setConversaAtual,
        perguntasAppAtual,
        erroPergunta,
        setErroPergunta,
        contextoPendente,
        setContextoPendente,
      }}
    >
      {children}
    </PerguntaContext.Provider>
  );
};

export const usePergunta = () => {
  const context = useContext(PerguntaContext);
  if (!context) {
    throw new Error("usePergunta deve ser usado com PerguntaProvider");
  }
  return context;
};
